import { Cross } from 'components/Icons'
import ResourceGroup from 'components/ResourceGroup'
import style from 'components/SearchPanel.module.scss'
import { useStores } from 'hooks/useStores'
import _ from 'lodash'
import toLower from 'lodash/toLower'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'

const SearchPanel = ({ allResources }) => {
  const [query, setQuery] = useState('')
  const [filteredResources, setFilteredResources] = useState([])

  const resources = allResources.nodes

  const handleChange = ev => {
    const { value } = ev.target

    setQuery(value)
  }

  const handleClear = ev => {
    setQuery('')
  }

  useEffect(() => {
    const queryLower = toLower(query)

    const queriedResources = resources.filter(r => {
      const titleLower = toLower(r.title)
      const urlLower = toLower(r.url)
      const keywordsLower = toLower(r.keywords)
      return (
        titleLower.includes(queryLower) ||
        urlLower.includes(queryLower) ||
        keywordsLower.includes(queryLower)
      )
    })

    setFilteredResources(queriedResources)
  }, [query, resources])

  return (
    <div className={style.root}>
      <div className={style.content}>
        <div className={style.header}>
          <div className={style.queryForm}>
            <input
              type="search"
              value={query}
              onChange={handleChange}
              className={style.input}
              placeholder="Search our resources..."
              autoFocus
            />
            {!!query && (
              <button
                className={style.clearButton}
                type="button"
                onClick={handleClear}
              >
                <Cross />
              </button>
            )}
          </div>
        </div>
        {!!query && filteredResources.length > 0 && (
          <div className={style.resources}>
            <ResourceGroup resources={filteredResources} />
          </div>
        )}
      </div>
    </div>
  )
}

export default observer(SearchPanel)
